module.exports = {
  social_deduction_games_online: {
    title: '線上陣營桌遊：阿瓦隆與狼人殺比較',
    description: '比較阿瓦隆、狼人殺與太空狼人殺的人數、淘汰和開局條件，了解瀏覽器遊玩與朋友揪團。',
    keywords: ['線上陣營桌遊'],
    breadcrumbs: [
      {
        to: '/zh-tw/',
        title: '首頁',
      },
      {
        to: '/zh-tw/guides/social-deduction-games-online/',
        title: '線上陣營桌遊',
      },
    ],
  },
  games_like_secret_hitler: {
    title: '類似揭密希特勒的桌遊：阿瓦隆比較',
    description: '比較投票、法案與梅林刺殺，了解 5–10 人朋友揪團或單人機器人練習怎麼開始。',
    keywords: ['類似揭密希特勒的桌遊'],
    breadcrumbs: [
      {
        to: '/zh-tw/',
        title: '首頁',
      },
      {
        to: '/zh-tw/guides/social-deduction-games-online/',
        title: '線上陣營桌遊',
      },
      {
        to: '/zh-tw/guides/games-like-secret-hitler/',
        title: '類似揭密希特勒的桌遊',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: '阿瓦隆和狼人殺的差別：淘汰與投票',
    description: '比較狼人殺角色與阿瓦隆角色、淘汰與任務投票，了解預言家和梅林的差別及線上開局方式。',
    keywords: ['阿瓦隆和狼人殺的差別'],
    breadcrumbs: [
      {
        to: '/zh-tw/',
        title: '首頁',
      },
      {
        to: '/zh-tw/guides/social-deduction-games-online/',
        title: '線上陣營桌遊',
      },
      {
        to: '/zh-tw/guides/avalon-vs-werewolf/',
        title: '阿瓦隆與狼人殺比較',
      },
    ],
  },
};
